module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/lung_sugery_method-d9f53b64205a0c41366370f9ad09032a.jpg";